/**
 * React hook to handle success with snackbar
 */

import { useEffect, useState } from 'react';

import Cookies from 'universal-cookie';

import { getCurrentAWSCognitoGroups } from '../../../services/auth';

const cookies = new Cookies();

const useUserGroups = () => {
  const cachedUserGroups = cookies.get('userGroups');
  const [userGroups, setUserGroups] = useState<string[]>(cachedUserGroups);

  useEffect(() => {
    const fetchUserGroups = async () => {
      const groups = await getCurrentAWSCognitoGroups();
      cookies.set('userGroups', groups, { path: '/' });
      setUserGroups(groups);
    };

    fetchUserGroups();
  }, []);

  return userGroups;
};

export default useUserGroups;
